module.exports = __webpack_public_path__ + "img/ShareDesktop.9cb8ea19.svg";